import React from "react";

const FinanceIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.44 15.18C17.53 16.26 18.52 17.05 19.6 17.05H21.5V18.24C21.5 20.31 19.81 22 17.74 22H6.26C4.19 22 2.5 20.31 2.5 18.24V11.51C2.5 9.44001 4.19 7.75 6.26 7.75H17.74C19.81 7.75 21.5 9.44001 21.5 11.51V12.95H19.48C18.92 12.95 18.41 13.17 18.04 13.55C17.62 13.96 17.38 14.55 17.44 15.18Z"
        fill="#3D68FF"
      />
      <path
        d="M14.85 7.75158H6.26C4.19 7.75158 2.5 9.44159 2.5 11.5116V7.8416C2.5 6.6516 3.23 5.59156 4.34 5.17156L12.28 2.17156C13.52 1.71156 14.85 2.62159 14.85 3.95159V7.75158Z"
        fill="#3055D4"
      />
      <path
        d="M22.5608 16.0292C22.5608 16.5792 22.1208 17.0292 21.5608 17.0492H19.6008C18.5208 17.0492 17.5308 16.2592 17.4408 15.1792C17.3808 14.5492 17.6208 13.9592 18.0408 13.5492C18.4108 13.1692 18.9208 12.9492 19.4808 12.9492H21.5608C22.1208 12.9692 22.5608 13.4192 22.5608 13.9692V16.0292Z"
        fill="white"
      />
      <path
        d="M7 12.75C6.59 12.75 6.25 12.41 6.25 12C6.25 11.59 6.59 11.25 7 11.25H14C14.41 11.25 14.75 11.59 14.75 12C14.75 12.41 14.41 12.75 14 12.75H7Z"
        fill="white"
      />
    </svg>
  );
};

export default FinanceIcon;
